import { createSlice } from "@reduxjs/toolkit";
import { StatementModel } from "../../models/GlobalModels";

interface AlertState {
    statements: StatementModel[];
}

const initialState: AlertState = {
    statements: [],
};

const statementSlice = createSlice({
    name: "statement",
    initialState,
    reducers: {
        setStatements(state, action) {
            state.statements = action.payload ?? [];
        },
    },
});

export const { setStatements } = statementSlice.actions;
export default statementSlice.reducer;
